import { toRelativeUrl } from '@okta/okta-auth-js';
import { playResultNamesQueryOptions } from '@sportybot-web/services/sporty-gateway/queries';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context }) => {
    const { authClient, queryClient } = context;

    if (!(await authClient.isAuthenticated())) {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin);
      await new Promise(() => authClient.signInWithRedirect({ originalUri }));
    }

    await queryClient.ensureQueryData(playResultNamesQueryOptions());
  },
  component: Outlet,
});
